import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgAdd2Alt = function SvgAdd2Alt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12 0C5.39 0 0 5.39 0 12s5.39 12 12 12 12-5.39 12-12S18.61 0 12 0zm0 21.984c-5.531 0-9.984-4.5-9.984-9.984 0-5.531 4.5-9.984 9.984-9.984 5.531 0 9.984 4.5 9.984 9.984A9.963 9.963 0 0112 21.984z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M12.005 5.383c-.53 0-.994.464-.994.995v4.64h-4.64c-.53 0-.995.464-.995.994s.464.995.995.995h4.64v4.64c0 .53.464.995.994.995.266 0 .53-.133.696-.299.166-.166.299-.43.299-.696v-4.64h4.64c.265 0 .53-.133.696-.298.166-.166.299-.431.299-.697 0-.53-.465-.994-.995-.994H13v-4.64a.94.94 0 00-.995-.995z"
  }));
};

export default SvgAdd2Alt;